import flatCombineReducers from "./flat-combine-reducers";
import reducers from "./reducers";
import Constants from "../utils/CommonConstants";

export const defaultState = {
  churnSchedulerList: [],
  userInfo: null,
  agentStatus: Constants.agentStatus.INACTIVE,
  chosenTab: {},
  agentBranchCityMap: {},
  makaanCitiesMap: {},
  isPlatformMakaan: false,
  housingSlotDetails: {},
  discountMatrixNetworkErr: {},
  slotAvailabilityDetails: {},
  accountDetailsUpdated: null,
  mergedAccountsStatus: {},
  liveListings: {
    BUY: null,
    RENT: null,
  },
  salesClosureDateMap: {},
  microsite: {},
  virtualTour: { list: [], data: {}, formData: {} },
  siteTakeover: { data: {}, formData: {} },
  siteTakeoverList: [],
  micrositeList: [],
  message: "",
  adProductConfig: {},
  flatPanel: { formData: {}, rejectionReasons: [] },
  upComingRenewals: {
    weekly: null,
    monthly: null,
  },
  modalInactiveProfileHousing: {},
  npStopSlotMap: {},
  parentComplimentaryProduct: null,
  complimentaryProductsList: [],
  deactivateComplimentaryProductMap: {},
  approvalLandingPageDetails: null,
  approvalLandingPageDetailsError: null,
  accountPaymentBucketTypeDetails: {},
  unutilizedPayments: {},
  npSlotPocDetails: null,
  npSwapSlotMap: {},
  resendAccountVerificationMap: {},
  hrisDetailsMap: {},
  audienceMaximizer: { data: {}, formData: {} },
  housingNeo: { data: {}, formData: {} },
  recordings: {
    filtersData: {
      filter: {
        missing_feedback: true,
        exclude_ids: true,
      },
    },
  },
  agentMappings: {
    list: [],
  },
  snackbar: {},
  sellerResponsive: {
    ticket: null,
    loading: false,
    error: null,
    snackbar: null,
  },
  // Sell Intelligence state
  sellIntelligence: {
    configurations: null,
    configurationsLoading: false,
    localityServices: {},
    insights: {},
    insightsLoading: false,
    comments: null,
    commentsLoading: false,
    acknowledgement: null,
    newConfigId: null,
    summary: null,
    summaryLoading: false,
  },
  // Call Insights (TATA/Kira call recording on the owner opportunity page)
  callInsights: {
    calls: null,
    loading: false,
    forbidden: false,
  },
};

const rootReducer = flatCombineReducers(...reducers);
export default rootReducer;
